const menu = {
    label: 'Aplicações',
    icon: 'pi pi-fw pi-users',
    to: '/controleacesso/aplicacoes',
    rules: ['CTRLACS-APP-00'],
};

export default menu;
